import { FirstCallFeature } from '../../../models/first-call';

function firstCallInfoPopUpContent(
  feature: mapboxgl.MapboxGeoJSONFeature
): { label: string; value: string }[] | null {
  if (feature) {
    const firstCallFeature = feature as unknown as FirstCallFeature;
    const { properties } = firstCallFeature;
    const { worldPortIndexNumber, portName, unLocode } = properties;

    const fields = [
      {
        label: 'First Call Port Name',
        value: portName,
      },
    ];

    if (worldPortIndexNumber) {
      fields.push({
        label: 'World Port Index No.',
        value: worldPortIndexNumber.toString(),
      });
    }
    if (unLocode) {
      fields.push({
        label: 'UN/LOCODE',
        value: unLocode,
      });
    }
    return fields;
  }
  return null;
}

export default firstCallInfoPopUpContent;
